import React, { Component } from 'react';
import { Table } from 'antd';
import moment from 'moment';
import util from '@util/index';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    const type = ['押金', '工位', '地址'];
    const payType = ['收入', '作废', '退回'];
    return [
      {
        title: '账单编号',
        dataIndex: 'payableNo',
        render: (text, record) => {
          return text || record.no;
        },
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        render: (text, record) => {
          return <span>{record.payType === 2 ? '退款' : type[text]}</span>;
        },
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '付款时间',
        dataIndex: 'date',
        render: (text, record) => (
          <span>
            <span>{text ? moment.unix(record.date / 1000).format('YYYY-MM-DD') : ''}</span>
          </span>
        ),
      },
      {
        title: '账单类型',
        dataIndex: 'payType',
        render: (text, record) => {
          return <span>{payType[text]}</span>;
        },
      },
      {
        title: '应收/退',
        dataIndex: 'price',
        render: (text, record) => {
          const element =
            record.payType === 2 ? (
              <span style={{ color: 'red' }}>退{util.numberFormat(text)}</span>
            ) : (
              <span style={{ color: 'green' }}>收{util.numberFormat(text)}</span>
            );
          return text > 0 ? element : 0;
        },
      },
      {
        title: '实收/退',
        dataIndex: 'confirm',
        render: (text, record) => {
          const element =
            record.payType === 2 ? (
              <span style={{ color: 'red' }}>退{util.numberFormat(text)}</span>
            ) : (
              <span style={{ color: 'green' }}>收{util.numberFormat(text)}</span>
            );
          return text > 0 ? element : 0;
        },
      },
      {
        title: '作废',
        dataIndex: 'obsolete',
        render: (text, record, index) => {
          return record.price > 0 && record.payType !== 2 ? <div>{text}</div> : null;
        },
      },
      {
        title: '违约金',
        dataIndex: 'damages',
        render: (text, record, index) =>
          record.type === 0 && record.confirm > 0 && record.payType !== 2 ? (
            <span>{text}</span>
          ) : null,
      },
      {
        title: '退回',
        dataIndex: 'refund',
        render: (text, record, index) => {
          return (
            <span>{record.confirm > 0 && record.payType !== 2 ? <span>{text}</span> : null}</span>
          );
        },
      },
    ];
  };

  render() {
    const { data } = this.props;
    return (
      <div>
        <Table columns={this.columns()} dataSource={data} pagination={false} />
      </div>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/termination/station/TableAppoint.js